import type { InputHTMLAttributes } from 'react';
import { cn } from './cn';

export const Input = ({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) => (
  <input
    className={cn(
      'block w-full rounded-control border border-border/40 bg-white/85 px-3.5 py-3 text-sm text-text shadow-[var(--shadow-hairline)] placeholder:text-muted/70 hover:border-text/40 focus:border-text focus:bg-white focus:outline-none focus:ring-2 focus:ring-accent/35 disabled:cursor-not-allowed disabled:bg-shade disabled:text-muted',
      className
    )}
    {...props}
  />
);
